'use client'

import * as GridLayout from '@/components/GridLayout/GridLayout'
import { type ExpectedBlockType, type GridColumnsField, type SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { StoryblokComponent, storyblokEditable } from '@storyblok/react'
import type { TextBlockProps } from './TextBlock/TextBlock'

export type TextContentBlockProps = SbBaseBlockProps<{
  body: ExpectedBlockType<TextBlockProps>
  layout?: GridColumnsField
}>

export const TextContentBlock = ({ blok, nested }: TextContentBlockProps) => {
  return (
    <GridLayout.Root {...storyblokEditable(blok)} nested={nested}>
      <GridLayout.Content width={blok.layout?.widths ?? '2/3'} align={blok.layout?.alignment ?? 'center'}>
        {blok.body.map((nestedBlock) => (
          <StoryblokComponent key={nestedBlock._uid} blok={nestedBlock} nested={true} />
        ))}
      </GridLayout.Content>
    </GridLayout.Root>
  )
}
TextContentBlock.blockName = 'textContent'
